<div class="row mb-5 d-flex justify-content-start">
	<!-- Affiche le menu déroulant si les conditions sont remplies -->
	<button
		*ngIf="addable && shouldShowDropdown()"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
		id="addDropdownButton"
		data-bs-toggle="dropdown"
		aria-expanded="false"
	>
		<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
	</button>
	<ul
		*ngIf="shouldShowDropdown()"
		class="dropdown-menu w-auto"
		aria-labelledby="addDropdownButton"
	>
		<li>
			<a
				class="dropdown-item theme-main-color"
				role="button"
				(click)="addEvent.emit($event)"
				>Prestation</a
			>
		</li>
		<li>
			<a
				class="dropdown-item theme-main-color"
				role="button"
				(click)="addEvent.emit($event)"
				>Série de prestations</a
			>
		</li>
	</ul>

	<!-- Affiche le bouton normal si les conditions ne sont pas remplies -->
	<button
		*ngIf="addable && !shouldShowDropdown()"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
		(click)="addEvent.emit($event)"
	>
		<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
	</button>

	<button
		*ngIf="isImportable"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-bs-light-button"
		(click)="importingEvent.emit($event)"
	>
		<i class="fs-5 bi bi-upload" aria-hidden="true"></i> Importer
	</button>
	<button
		*ngIf="isExportable"
		class="col-lg-2 col-5 my-2 mx-2 btn theme-bs-light-button"
		(click)="exportingEvent.emit($event)"
	>
		<i class="fs-5 bi bi-download" aria-hidden="true"></i> Exporter
	</button>
</div>

<div>
	<ul class="nav border-bottom">
		<li
			class="nav-item col-xs-6 overflow-hidden text-nowrap"
			*ngFor="let tab of tabs"
		>
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="[tab.path]"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 border-custom-theme':
						isRouterActive(tab.parentPath)
				}"
				>{{ tab.name }}</a
			>
		</li>
	</ul>
</div>
